import getKhattabatSelectsStore from "../../../../stores/khattabat-stores/selects-store";
import {
  TalkhattabatConversationType,
  TSelectionPages
} from "../../../../Types";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import IgnoreConversation from "../../matching/shared/IgnoreConversation";
import getKhattabatBulkMessagingStore from "../../../../stores/khattabat-stores/messaging-stores/bulk-messaging-store";

const SideBulkActions = withLiteObserverAndTheme<{
  conversationType: TalkhattabatConversationType;
}>((props) => {
  const { conversationType } = props;
  const pageType: TSelectionPages =
    conversationType === "101M" ? "matchResultPage" : "clientPage";

  const { isOpenedBulkMessagesBox } = getKhattabatBulkMessagingStore();
  const { getMarkedUserIds } = getKhattabatSelectsStore();
  const shouldShowConversations = isOpenedBulkMessagesBox.get();

  return !shouldShowConversations ? null : (
    <ET3Div
      width={300}
      height={400}
      alignItems={"center"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      <IgnoreConversation
        pageType={pageType}
        matchIDs={getMarkedUserIds()}
        hasOneOTwoWithClient={false}
      />
    </ET3Div>
  );
});

export default SideBulkActions;
